"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequestGroupCreditCard = exports.AMEX_BRAND = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_types_1 = require("@as-react/common-types");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const useABTest_1 = require("../../../hooks/useABTest");
const useSaferpay_1 = require("../../../hooks/useSaferpay");
const PaymentRequestGroupContent_1 = require("./PaymentRequestGroupContent");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const NewCreditCardForm_1 = require("../payment/payment-groups/credit-card/NewCreditCardForm");
exports.AMEX_BRAND = 'American Express';
const PaymentRequestGroupCreditCard = ({ selected, group, onSubmit }) => {
    const paymentGroupContentRef = (0, react_1.useRef)();
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.buy);
    const { hasBCookie: disableAmexPaymentCookie } = (0, useABTest_1.useABTest)(common_types_1.ABTestCookie.DISABLE_AMEX_PAYMENT);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [showError, setShowError] = (0, react_1.useState)(false);
    const [saveCreditCardForFutureUse, setSaveCreditCardForFutureUse] = (0, react_1.useState)(false);
    const paymentMethods = group.paymentOptions.map(option => option.name.toLowerCase());
    let groupOgoneAliases = group.ogoneAliases || [];
    if (disableAmexPaymentCookie) {
        groupOgoneAliases = groupOgoneAliases.filter(card => card.brand !== exports.AMEX_BRAND);
    }
    const isAddNewCardSelected = !groupOgoneAliases.length;
    const { hasError: hasSaferpayError, validation } = (0, useSaferpay_1.useSaferpay)({
        paymentMethods,
        cvvPlaceholder: true,
        enabled: selected && isAddNewCardSelected,
    });
    const handleSaveCreditCardChange = () => setSaveCreditCardForFutureUse(prev => !prev);
    const isSubmitDisabled = Boolean(!!hasSaferpayError || showError);
    const newCreditCardFormProps = {
        paymentMethods,
        validation,
        isSubmitDisabled,
        isSubmitting,
        showSaveCardBlock: false,
        saveCreditCard: saveCreditCardForFutureUse,
        onSaveCreditCardChange: handleSaveCreditCardChange,
    };
    const submitWithNewCard = () => {
        window.SaferpayFields.submit({
            onSuccess: ({ token }) => {
                try {
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(token);
                }
                catch (_a) {
                    setIsSubmitting(false);
                    setShowError(true);
                }
            },
            onError: () => {
                setIsSubmitting(false);
            },
        });
    };
    const onHandleSubmit = () => {
        setIsSubmitting(true);
        setShowError(false);
        submitWithNewCard();
    };
    return ((0, jsx_runtime_1.jsx)(PaymentRequestGroupContent_1.PaymentRequestGroupContent, { onSubmit: onHandleSubmit, selected: selected, group: group, disabled: isSubmitDisabled, isSubmitting: isSubmitting, error: hasSaferpayError || showError ? t('buy.payment.form.error') : undefined, innerRef: paymentGroupContentRef, children: selected && (0, jsx_runtime_1.jsx)(NewCreditCardForm_1.NewCreditCardForm, Object.assign({}, newCreditCardFormProps)) }));
};
exports.PaymentRequestGroupCreditCard = PaymentRequestGroupCreditCard;
